import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicComponent } from './public.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UserInvitationResponseComponent } from './invitations/user-invitation-response/user-invitation-response.component';
import { ConfirmingSupplierInvitationResponseComponent } from './invitations/confirming/supplier-invitation-response/supplier-confirming-invitation-response.component';
import { ConfirmingBuyerInvitationResponseComponent } from './invitations/confirming/buyer-invitation-response/buyer-invitation-response.component';
import { FactoringSupplierInvitationResponseComponent } from './invitations/factoring/supplier-invitation-response/supplier-invitation-response.component';
import { ResetLoggedInformationComponent } from './reset-logged-information/reset-logged-information.component';
import { MfaSelectComponent } from './mfa/mfa-select/mfa-select.component';
import { MfaVerifyComponent } from './mfa/mfa-verify/mfa-verify.component';
import { MfaSetUpOtpPageComponent } from './mfa/mfa-setup-otp-page/mfa-setup-otp-page.component';

const routes: Routes = [
	{
		path: 'public',
		component: PublicComponent,
		children: [
			{
				path: '',
				component: LoginComponent,
			},
			{
				path: 'login',
				component: LoginComponent,
			},
			{
				path: 'login/resetLoggedInformation',
				component: ResetLoggedInformationComponent,
			},
			{
				path: 'recover-password',
				loadChildren: () => import('./recover-password/recover-password.module').then((m) => m.RecoverPasswordModule),
			},
			{
				path: 'reset-password',
				component: ResetPasswordComponent,
			},
			{
				path: 'user-invitation-response/:invitationContext',
				component: UserInvitationResponseComponent,
			},
			{
				path: 'invitation/company/new/supplier/confirming-invitation-response/:invitationContext',
				component: ConfirmingSupplierInvitationResponseComponent,
			},
			{
				path: 'invitation/company/new/buyer/confirming-invitation-response/:invitationContext',
				component: ConfirmingBuyerInvitationResponseComponent,
			},
			{
				path: 'invitation/company/existing/confirming-invitation-response/:invitationContext',
				component: ConfirmingSupplierInvitationResponseComponent,
			},
			{
				path: 'invitation/company/new/supplier/factoring-invitation-response/:invitationContext',
				component: FactoringSupplierInvitationResponseComponent,
			},
			{
				path: 'mfa-select',
				component: MfaSelectComponent,
			},
			{
				path: 'mfa-verify',
				component: MfaVerifyComponent,
			},
			{
				path: 'mfa-setup-otp',
				component: MfaSetUpOtpPageComponent,
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class PublicRoutingModule {}
